import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "-5 -5 85 85",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-5 -5 85 85\" id=\"icon-user\"><path d=\"M42.72,36.65C53.64,42.06,59.5,50.71,60.13,63H54.35A22.77,22.77,0,0,0,46,45.3a22.41,22.41,0,0,0-14.78-5.2A23,23,0,0,0,8.43,63H2.92C2.36,56.51,6.2,43,20.13,36.68c-6.39-4.86-9.48-11.22-8.54-19.25A19,19,0,0,1,18.82,4.5a20,20,0,1,1,23.9,32.15Zm3-16.63A14.32,14.32,0,1,0,31.42,34.36,14.32,14.32,0,0,0,45.74,20Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol